import client from './client';
import { Disease, DiseaseCreate, DiseaseUpdate, DiseaseListItem } from '../types/disease';

export const searchDiseases = async (query: string, limit: number = 20): Promise<DiseaseListItem[]> => {
  const response = await client.get('/api/v1/diseases/search', {
    params: { q: query, limit },
  });
  return response.data.results;
};

export const getDisease = async (id: string): Promise<Disease> => {
  const response = await client.get(`/api/v1/diseases/${id}`);
  return response.data;
};

export const createDisease = async (data: DiseaseCreate): Promise<Disease> => {
  const response = await client.post('/api/v1/diseases/', data);
  return response.data;
};

export const updateDisease = async (id: string, data: DiseaseUpdate): Promise<Disease> => {
  const response = await client.put(`/api/v1/diseases/${id}`, data);
  return response.data;
};

export const deleteDisease = async (id: string): Promise<void> => {
  await client.delete(`/api/v1/diseases/${id}`);
};
